import React from 'react'
import {isMobile} from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import Img from 'gatsby-image'

class Hero extends React.Component{

    render(){
        const innerJSX = (
            <div>
                <div className="uk-position-absolute uk-position-top uk-cover-background uk-height-viewport allcor-overlay">
                    {this.props.title 
                    ?
                    <div className="uk-overlay uk-position-bottom">
                        <h1>{this.props.title}</h1>
                    </div>
                    :
                    ''
                    }
                </div>
                <AnchorLink className="more" href="#main">
                    <FontAwesomeIcon icon="chevron-down" />
                </AnchorLink>
            </div>
            );

        if (isMobile) {
            return (
                <section className="hero">
                    <div className="uk-cover-container uk-height-viewport mobile-cover">                   
                        <Img fluid={this.props.mobile} className="uk-height-viewport"/>
                    </div>
                    {innerJSX}
                    
                </section>
            )
        }
        return(
            <section className="hero">
                <div className="uk-cover-container uk-height-viewport video-container">                   
                    <video autoPlay="true" loop="true" muted="true" className="uk-height-viewport uk-cover">
                        <source src={this.props.video} type="video/mp4"/>
                    </video>
                </div>
                { innerJSX }
            </section>
        )
    }
}

export default Hero